import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { Post } from "../types/post.types";

export function usePosts(broadcastId: string | null): Post[] {
	const [posts, setPosts] = useState<Post[]>([]);

	useEffect(() => {
		if (!broadcastId) return;

		const q = query(
			collection(db, "broadcasts", broadcastId, "posts"),
			orderBy("date", "desc"),
		);

		const unsubscribe = onSnapshot(q, (snapshot) => {
			setPosts(
				snapshot.docs.map((doc) => ({
					id: doc.id,
					...(doc.data() as Omit<Post, "id">),
				})),
			);
		});

		return unsubscribe;
	}, [broadcastId]);

	return posts;
}
